<template>
  <div class="pagination">
    <ul>
      <li v-show="currentPage > 1"><a class="_prev" @click="updatePage(currentPage - 1)"></a></li>
      <li v-for="page in paginationPages" :key="page"><a :href="'?page=' + page" @click="updatePage(page, $event)" :class="{ '_current': page === currentPage, 'first': page === 1 }">{{ page }}</a></li>
      <li v-show="currentPage < totalPages"><a class="_next" @click="updatePage(currentPage + 1)"></a></li>
    </ul>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component({
    name: 'product-list-toolbar-paginator'
  })

  export default class extends Vue {
    @Prop({required: true}) private dataSource: string;
    @Prop({default: 2}) private interval: number;

    get currentPage(): number {
      return Number(this.$store.getters[`${this.dataSource}/currentPage`]);
    }

    get totalPages(): number {
      return Number(this.$store.getters[`${this.dataSource}/totalPages`]);
    }

    get paginationPages(): Array<number> {
      let pages = [];
      for (let i = this.paginationStart; i <= this.paginationEnd; i++) {
        pages.push(i);
      }
      return pages;
    }

    get paginationStart(): number {
      return this.currentPage <= this.interval ? 1 : (this.currentPage - this.interval);
    }

    get paginationEnd(): number {
      if ((this.currentPage + this.interval) < this.totalPages) {
        return this.currentPage + this.interval;
      }

      return this.totalPages;
    }

    updatePage(page, $event): void {
      if ($event) {
        $event.preventDefault();
      }
      if (page !== this.currentPage) {
        this.$store.dispatch(`${this.dataSource}/updatePage`, page);
      }
      let elem = document.getElementById("solar-app");
      elem.scrollIntoView();
    }
  }
</script>
